// extracted by mini-css-extract-plugin
export default {"listTitle":"Pg_5_2_listTitle__pUOIQ"};